type GenericObject = {
  [a: string]: string;
};

export const apiErrorMessages: GenericObject = {
  Unauthorized: `Email e/ou Senha incorretos`,
  default: "Algo deu errado ao se comunicar com o servidor.",
  couponInvalid: "*cupom inválido",
};
